import React from 'react';
import { StatusIconProps } from './utils';

function WarningCircle({ width, height }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 14C12.5523 14 13 14.4477 13 15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14ZM12 7C12.5082 7 12.9201 7.41196 12.9201 7.92013L12.917 7.99655L12.5382 12.5415C12.5166 12.8007 12.3 13 12.0399 13H11.9601C11.7 13 11.4834 12.8007 11.4618 12.5415L11.083 7.99655C11.0408 7.49013 11.4172 7.04538 11.9236 7.00318C11.949 7.00106 11.9745 7 12 7Z"
        fill="#2D2D2D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12ZM13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15ZM12.9201 7.92013C12.9201 7.41196 12.5082 7 12 7C11.9745 7 11.949 7.00106 11.9236 7.00318C11.4172 7.04538 11.0408 7.49013 11.083 7.99655L11.4618 12.5415C11.4834 12.8007 11.7 13 11.9601 13H12.0399C12.3 13 12.5166 12.8007 12.5382 12.5415L12.917 7.99655L12.9201 7.92013Z"
        fill="#FFCD00"
      />
    </svg>
  );
}
WarningCircle.propTypes = StatusIconProps;

export default WarningCircle;
